"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EFormsDataElementCategory_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var EFormsDataElement_1 = require("./EFormsDataElement");
var EFormsDataElementCategory_Factory = /** @class */ (function () {
    function EFormsDataElementCategory_Factory() {
    }
    EFormsDataElementCategory_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            DataElements: model.DataElements && model.DataElements.map(function (i) { return EFormsDataElement_1.EFormsDataElement_Factory.CreateIncoming(i); }),
            Name: model.Name,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    EFormsDataElementCategory_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            DataElements: model.DataElements && model.DataElements.map(function (i) { return EFormsDataElement_1.EFormsDataElement_Factory.CreateOutgoing(i); }),
            Name: model.Name,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    return EFormsDataElementCategory_Factory;
}());
exports.EFormsDataElementCategory_Factory = EFormsDataElementCategory_Factory;
